import { Component, OnInit, Input } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import {AuthenticationService} from "../../../_services";

@Component({
    selector: 'app-admin-left-side',
    templateUrl: './admin-left-side.component.html',
    styleUrls: ['./admin-left-side.component.css']
})
export class AdminLeftSideComponent implements OnInit {

    @Input() displayName: string;
    @Input() isRootAdmin: boolean;

    public isUserConnectLine: boolean;
    public isConnectedTwitter: boolean;
    constructor(private authenticationService: AuthenticationService) { }

    ngOnInit() {
        let tokenPayload = this.authenticationService.checkRoleUser();

        this.isUserConnectLine = !tokenPayload.isAdmin && this.authenticationService.getFieldUserCurrent('existUserConnect');
        this.isConnectedTwitter = !tokenPayload.isAdmin && this.authenticationService.getFieldUserCurrent('connectTwitter');
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_layouts/admin/admin-left-side/admin-left-side.component.ts